export { default as BuscarAlumnos } from './BuscarAlumnos';
export { default as Inscribir } from './Inscribir';



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/componentes/index.ts